import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notification-content" }
const _hoisted_2 = { class: "notification-message d-flex align-items-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "badge-custom me-2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "w-100 d-flex justify-content-center"
}
const _hoisted_7 = { class: "d-flex flex-column flex-sm-row align-items-center text-center" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notification-bar", { show: _ctx.showPopup }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isIos)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('install_app.install')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('install_app.open_safari')) + " ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('install_app.share')), 1),
              _cache[2] || (_cache[2] = _createTextVNode(" (", -1)),
              _createElementVNode("img", {
                src: _ctx.shareIcon,
                alt: "Share icon",
                class: "me-1"
              }, null, 8, _hoisted_5),
              _createTextVNode("), " + _toDisplayString(_ctx.$t('install_app.then')) + " ", 1),
              _createElementVNode("strong", null, "\"" + _toDisplayString(_ctx.$t('install_app.add_to_home')) + "\"", 1),
              _cache[3] || (_cache[3] = _createTextVNode(". ", -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: "badge-custom me-0 me-sm-2 mb-2 mb-sm-0",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.installApp && _ctx.installApp(...args)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('install_app.install')) + " ", 1),
                  _createElementVNode("img", {
                    src: _ctx.downloadIcon,
                    alt: "Download icon",
                    class: "ms-1 mb-1"
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('install_app.better_exp')), 1)
              ])
            ]))
      ]),
      _createElementVNode("button", {
        class: "close-button",
        "aria-label": "Close notification",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
      }, " × ")
    ])
  ], 2))
}